<template>
  <zen-one 
    :showuserinfo="false" 
    :crumbs="crumbs"
    title="Sistem Hasil Bersepadu Kedah (iHasil)"
  >
    <z-page title="Paparan Arahan Pembayaran" >

    <w-card bg-color="" class="">
        <w-flex justify-center align-center>
            <div class="xs4">
                  <h5 class="fw-semibold m0">
                      No. Bayaran :
                  </h5>
                  <div class="fw-normal my1 fs-1"> {{form.no_bayaran}} </div>
            </div>
            <div class="xs4">
                  <h5 class="fw-semibold m0">
                      Tarikh Daftar :
                  </h5>
                  <div class="fw-normal my1 fs-1"> {{$zutil.dateformat(form.created_at)}}</div>
            </div>
            <div class="xs4">
                  <h5 class="fw-semibold m0">
                      Kod Akaun :
                  </h5>
                  <div class="fw-normal my1 fs-1"> {{form.akaun_kod}} | {{form.akaun_keterangan}}</div>
            </div>
        </w-flex>
        <w-flex justify-center align-center>
            <div class="xs4">
                  <h5 class="fw-semibold m0">
                      Kod Vot :
                  </h5>
                  <div class="fw-normal my1 fs-1"> {{form.vot_kod}} | {{form.vot_keterangan}} </div>
            </div>
            <div class="xs4">
                  <h5 class="fw-semibold m0">
                      Tarikh Terima Dokumen Di Kewangan:
                  </h5>
                  <div class="fw-normal my1 fs-1"> {{$zutil.dateformat(form.tarikh_kew_terima)}}</div>
            </div>

            <div class="xs4">
                  <h5 class="fw-semibold m0">
                      Tarikh Terima Dokumen Di Jabatan:
                  </h5>
                  <div class="fw-normal my1 fs-1"> {{$zutil.dateformat(form.tarikh_jab_terima)}}</div>
            </div>
        </w-flex>
        <w-flex justify-center align-center>
            <div class="xs4">
                  <h5 class="fw-semibold m0">
                      No. Dokumen :
                  </h5>
                  <div class="fw-normal my1 fs-1"> {{form.no_dokumen}} </div>
            </div>
            <div class="xs4">
                  <h5 class="fw-semibold m0">
                      Tarikh Dokumen :
                  </h5>
                  <div class="fw-normal my1 fs-1"> {{$zutil.dateformat(form.tarikh_dokumen)}}</div>
            </div>

            <div class="xs4">
                  <h5 class="fw-semibold m0">
                      Keterangan :
                  </h5>
                  <div class="fw-normal my1 fs-1"> {{form.keterangan}} </div>
            </div>
        </w-flex>
        <w-flex justify-center align-center>
            <div class="xs4">
                  <h5 class="fw-semibold m0">
                      Status :
                  </h5>
                  <div class="fw-normal my1 fs-1"> {{form.status_keterangan}} </div>
            </div>
            <div class="xs4">
                  <h5 class="fw-semibold m0">
                  </h5>
                  <div class="fw-normal my1 fs-1"> </div>
            </div>
            <div class="xs4">
                  <h5 class="fw-semibold m0">
                  </h5>
                  <div class="fw-normal my1 fs-1"> </div>
            </div>
        </w-flex>
    </w-card>

    <w-tabs :items="tabs" :no-slider="false" active-class="primary">  
    <template #item-content.1>  
        <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="onSuccess">    
            <w-flex justify-center align-center>
                <div class="w-card__content content-hardcode">
                    <table class="table-dashboard" width="100%">
                        <thead>
                            <tr>
                              <td >No</td>
                                <td>Nama Penerima Bayaran</td>
                                <td>Bank Penerima Bayaran</td>
                                <td>No. Akaun Penerima Bayaran</td>
                                <td>Catatan</td>
                                <td>Amaun Bayaran (RM)</td>
                            </tr>
                        </thead>
                        <tbody>
                        <tr v-for="dt, index in form.butiran">
                            <td>{{(index+1)}}</td>
                            <td >
                                {{dt.profil_nama}}
                            </td>
                            <td>
                                {{dt.bank_keterangan}}
                            </td>
                            <td>
                              {{dt.no_akaun}}
                            </td>
                             <td>
                              {{dt.catatan_bayaran}}
                            </td>
                            <td align="right">
                                {{$zutil.currency(dt.amaun)}}
                            </td>
                        </tr>
                        <tr >
                          <td colspan="5">Jumlah</td>
                          <td align="right">{{$zutil.currency(form.amaun)}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </w-flex>

            <w-flex class="mt3" wrap align-center justify-end>
              <template v-if="form.lkp_bayaran_status_id == 3 && $zutil.can('Bayaran Lulus')">  
                  <w-button class="my1 error-dark1--bg" @click="send(6)" type="button" :disabled="form.valid === false" :loading="form.submitted && !form.sent">
                      <w-icon dark tile class="mr2"> fal fa-times mr2</w-icon> Batal
                  </w-button>
              </template>
              &nbsp; &nbsp;
              <w-button class="my1" bg-color="warning" dark  @click="back()" >Kembali</w-button>
              &nbsp; &nbsp;
              <template v-if="form.lkp_bayaran_status_id == 2 && $zutil.can('Bayaran Semakan')">
                    <w-button class="my1" bg-color="error-dark1" dark  @click="send(5)" >
                         <w-icon dark tile class="mr2">fal fa-times</w-icon> Semak Semula
                    </w-button>
                    &nbsp; &nbsp;
                     <!-- <w-button class="my1"  :disabled="form.valid === false" :loading="form.submitted && !form.sent" @click="send(3)">
                        <w-icon dark tile class="mr2">fal fa-paper-plane</w-icon> Semak
                    </w-button> -->
                  </template>
                  <template v-if="form.lkp_bayaran_status_id == 2 && $zutil.can('Bayaran Lulus')">
                    
                     <w-button class="my1"  :disabled="form.valid === false" :loading="form.submitted && !form.sent" @click="send(4)">
                        <w-icon dark tile class="mr2">fal fa-paper-plane</w-icon> Lulus
                    </w-button>
                  </template>
            </w-flex>

        </w-form>
      </template>
      <template #item-content.2>
        <z-jejak-audit :jejak_audit="form.jejak_audit" />
      </template>
    </w-tabs>
  
    </z-page>
  </zen-one>
</template>

<script>

import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    
  },
  props: {
    id: [Array, Object, String],
  },
  data() {
    return {

  
      resourceurl: this.service_pembayaran+'bayaran',
      reload: true,
      
      tabs: [
          { title: 'Butiran', content: '' },
          { title: 'Jejak Audit', content: '' },
      ],
      crumbs: [
        { label: 'iHasil', route: '/' },
        { label: 'Bayaran', route: '/bayaran' },
        { label: 'Papar', route: '/bayaran/'+this.id },
      ],
    }
  },
  methods: {
    back() {
      window.history.back();
    },
    send(status){
      this.form.lkp_bayaran_status_id = status
      this.$zcomm.update(this.resourceurl + '/'+this.form.id, this.form.id, this.form)
                  .then(res => {
                      

                    if (typeof this.onAfterEdit === "function") {
                        this.onAfterEdit()
                      }
                      this.$inertia.visit(this.$route('bayaran.index'))
                  })
                  .catch(err => {

                  })
                  .finally(() => {
                      

                  });
    
    }
  
  },
  watch: {

  },
  mounted() {
    
      
  },
    
}
</script>